import React from 'react';
import {CreateGuesser} from "@api-platform/admin";

const AirportInfoCreate = props => (
        <CreateGuesser {...props} resource="covid19-airport-infos"/>
);

export default AirportInfoCreate;
